<template>
  <div class="sp-layout-builder">
    <component :is="viewComponent" :rowgap="rowgap">
      <slot />
    </component>
  </div>
</template>

<script>
import { computed, h } from "vue";

import LayoutBuilderView from "./components/LayoutBuilder/LayoutBuilderView.ce.vue";
import LayoutBuilderContextMenu from "./components/LayoutBuilderContextMenu/LayoutBuilderContextMenu.ce.vue";
import PageBuilderView from "./components/PageBuilder/PageBuilderView.ce.vue";
import PageBuilderContextMenu from "./components/PageBuilderContextMenu/PageBuilderContextMenu.ce.vue";

const ViewTypes = Object.freeze({
  "layout-builder-view": LayoutBuilderView,
  "layout-builder-context-menu": LayoutBuilderContextMenu,
  "page-builder-view": PageBuilderView,
  "page-builder-context-menu": PageBuilderContextMenu,
  unknown: () => h("p", "Unable to initialize SpLayoutBuilder"),
});
</script>

<script setup>
const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => Object.keys(ViewTypes).includes(value),
  },
  rowgap: {
    type: String,
    default: undefined,
  },
});

const viewComponent = computed(() => ViewTypes[props.type] ?? ViewTypes.unknown);
</script>

<style>
:host {
  --row-full-bleed-vw: 100vw;
}
</style>
